module.exports = __webpack_public_path__ + "static/media/abbiamoCard.e4a78f1d.png";